import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';
import AuthenticationService from '@/services/Authentication';

export default async (to, from, next) => {
  try {
    // First check if user is authenticated
    const user = await getCurrentUser();
    
    // If user exists, get the session
    const session = await fetchAuthSession();
    
    // Handle the case where session might not have tokens yet
    if (!session.tokens || !session.tokens.accessToken) {
      throw new Error('No valid session tokens');
    }
    
    const data = {
      accessToken: {
        jwtToken: session.tokens.accessToken.toString(),
        payload: session.tokens.accessToken.payload
      },
      idToken: {
        payload: session.tokens.idToken ? session.tokens.idToken.payload : {}
      }
    };
    
    AuthenticationService.setUserSession(data);
    AuthenticationService.setToken(data.accessToken.jwtToken);
    localStorage.setItem('ma-token', data.accessToken.jwtToken);
    const { userGroups } = AuthenticationService;
    const isActiveUser = !!userGroups && userGroups.indexOf('User') !== -1;
    const isSysAdmin = !!userGroups && userGroups.indexOf('SysAdmin') !== -1;
    const isDevAdmin = !!userGroups && userGroups.indexOf('DevAdmin') !== -1;
    if (isActiveUser || isSysAdmin || isDevAdmin) {
      next();
      return;
    }
    const redirectRoute = {
      path: '/401',
    };
    next(redirectRoute);
  } catch (err) {
    console.log(err);
    console.log('is Auth error', err);
    const redirectRoute = {
      path: '/login',
      query: {
        redirect: to.fullPath,
      },
    };
    next(redirectRoute);
  }
};
